import React from "react";
import {
  Box,
  Grid,
  Typography,
  Link,
  makeStyles,
  Container,
} from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import MobileAppStoreMenu from "../../components/MobileAppStoreMenu/MobileAppStoreMenu";
import { ANDROID_APP_OPTIONS, IOS_APP_OPTIONS } from "../../constants/mobileApps";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#1e293b",
    color: "#ffffffcc",
    padding: theme.spacing(6, 4),
    fontSize: "0.9rem",
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: "#fff",
  },
  link: {
    display: "block",
    color: "#ffffffcc",
    marginBottom: theme.spacing(1),
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  iconGroup: {
    display: "flex",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  bottomBar: {
    borderTop: "1px solid #334155",
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    fontSize: "0.75rem",
    color: "#94a3b8",
  },
  iconImage: {
    height: 36,
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <Box
      component="footer"
      style={{ marginTop: "3rem" }}
      sx={{
        backgroundColor: "#0D3B66",
        color: "#fff",
        pt: 4,
        pb: 2,
        width: "100%",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <img
                src="https://artistimages.blob.core.windows.net/montestory/logo 2.svg"
                alt="Logo"
                style={{ width: "85px" }}
              />
            </Box>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Smart school management for young learners
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }}>
              Quick Links
            </Typography>
            <br />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link href="#/montessori/home" underline="hover" color="inherit">
                Home
              </Link>
              <Link href="#/montessori/about" underline="hover" color="inherit">
                About Us
              </Link>
              <Link href="#/montessori/contact" underline="hover" color="inherit">
                Contact Us
              </Link>
              <Link href="#/montessori/schoolregistration" underline="hover" color="inherit">
                School Registration
              </Link>
              <Link href="#/montessori/login" underline="hover" color="inherit">
                Login
              </Link>
              <Link href="#/montessori/delete-news-enquiry" underline="hover" color="inherit">
                Enquiry For Delete Account
              </Link>

              <br />
              <div className="pt-3">
                <h4 className="uppercase text-xs font-semibold text-gray-300">Download From</h4>
                <div className="flex space-x-4 mt-2">
                  <MobileAppStoreMenu options={IOS_APP_OPTIONS}>
                    <a href="#" aria-label="App Store" style={{ cursor: "pointer" }}>
                      <img
                        src="/images/apple logo.svg"
                        alt="iOS apps"
                        className={classes.iconImage}
                        style={{ marginRight: "15px" }}
                      />
                    </a>
                  </MobileAppStoreMenu>
                  <MobileAppStoreMenu options={ANDROID_APP_OPTIONS}>
                    <a href="#" aria-label="Play Store" style={{ cursor: "pointer" }}>
                      <img src="/images/android logo.svg" alt="Android apps" className={classes.iconImage} />
                    </a>
                  </MobileAppStoreMenu>
                </div>
              </div>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }}>
              Support
            </Typography>
            <br />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link href="#/montessori/privacy" underline="hover" color="inherit">
                Privacy Policy
              </Link>
              <Link href="#/montessori/refund-cancellation" underline="hover" color="inherit">
                Refund and Cancellation Policy
              </Link>
              <Link href="#/montessori/term" underline="hover" color="inherit">
                Terms of Service
              </Link>
              <Link href="#/montessori/problemswesolve" underline="hover" color="inherit">
                Problems We Solve
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }}>
              Contact
            </Typography>
            <br />
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <EmailIcon sx={{ mr: 1 }} />
              <Typography variant="body2">amar@srshta.com</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <PhoneIcon sx={{ mr: 1 }} />
              <Typography variant="body2">+91 8247625893</Typography>
            </Box>
            <Box sx={{ mt: 1.5, maxWidth: 280 }}>
              <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                4-9-197, St no 7, HMT Nagar, Hyderabad 500076, Telangana, India
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            borderTop: "1px solid rgba(255, 255, 255, 0.2)",
            mt: 4,
            pt: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            © 2025 Montestory. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
